import React,{useEffect, useState} from 'react'
import Header from '../Navbar/page'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Sidenavbar from '../Navbar/sideNav/page';
import Api from '../Api/Api';
import * as yup from 'yup';
import FooterSection from '../footer/page'
import {RingLoader} from 'react-spinners'

function Profilesection() {
    const [userEditProfile, setUserEditProfile] = useState("profilesection")
    const [loginButtonLoader,setLoginButtonLoader]=useState(true)
    const [UserProfile, setUserprofile] = useState({})
    const [show, setShow] = useState(false);
    const [eyeIconManagersinup, setEyeIconManagersinup] = useState(false)
    const [eyeIconManagersSinupConfirm, setEyeIconManagersSinupConfirm] = useState(false)
    const [eyeIconManag,setEyeIconManag]=useState(false)
    const [Loading,setLoading]=useState(false)

    const navigator = useNavigate();
  
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    
    const modelDisplay = () => {
        handleShow()
    }

    const ProfileData=async()=>{
      const token = localStorage.getItem("Quizetoken");
      if (!token) {
        setLoading(false);
        return; // Don't call API if user is not logged in
      }
      
      setLoading(true)
        try{
            const response = await Api.get("/user/get-profile")
        //  console.log("Dattataat---->",response.data.result)
         setUserprofile(response.data.result)
        }catch(error){
            console.log(error)
        }
        setLoading(false)
    }

    const logoutFun=()=>{
        // localStorage.removeItem("Quizetoken")
        // localStorage.removeItem("UserIdclient")
        // localStorage.removeItem("UserIdMongo")
        localStorage.clear();
        navigator('/')
    }

    const formik=useFormik({  
        initialValues: {
            name:UserProfile.userName || "",
            email:UserProfile.email || "",
            // phone:UserProfile.phone || "",
        },
        
        onSubmit: async (values,{resetForm}) => {
          setLoginButtonLoader(false)
          try{
            const response = await Api.patch("/user/update-profile/", values)
         toast(response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
      });
        }catch(error){
            // console.log(error)
            toast(error.response.data.message, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              type: 'error'
          });
        }
        setLoginButtonLoader(true)
        resetForm()
        },
        enableReinitialize: true,
      })


    const formikpass=useFormik({  
        initialValues: {
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        },
        validationSchema: yup.object({
          oldPassword: yup
            .string()
            .required("Old  Password is required")
            .min(6, "Old Password should be at least 6 characters")
            .max(40, "Old Password should not exceed 40 characters"),
            newPassword: yup
            .string()
            .required("Password is required")
            .min(6, "Password should be at least 6 characters")
            .max(40, "Password should not exceed 40 characters"),
            confirmPassword: yup
            .string()
            .required("Confirm Password is required")
            .oneOf([yup.ref("newPassword"), null], "Passwords must match"),
            
        }),
        onSubmit: async (values,{resetForm}) => {
          setLoginButtonLoader(false)
          try{
            const response = await Api.patch("/user/update-password/", values)
         toast(response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,  
      });
        }catch(error){
            // console.log(error)
            toast(error.response.data.message, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              type: 'error'
          });
        }
        setLoginButtonLoader(true)
        resetForm()
        
        }
      })

    
    useEffect(()=>{
      ProfileData()
    },[])



  return (
    <>
      <ToastContainer />
      {/* <div className="layout has-sidebar fixed-sidebar fixed-header">
        <Sidenavbar />
        <div className="layout" style={{ height: "100%" }}>
          <main className="content">
            <Header /> */}
      {Loading ? (
        <div
          className="d-flex justify-content-center"
          style={{ marginTop: "30%", marginBottom: "20%" }}
        >
          {/* <Loader/> */}
          <RingLoader color="rgb(50 92 213)" size="100" />
        </div>
      ) : (
        <>
          {/* <Header /> */}
          <div
            className="container pos-rel pt-120 pb-80"
            style={{ height: "98%" }}
          >
            <div className="row justify-content-center coupon-page-1">
              <div style={{ cursor: "pointer" }}>
                <i
                  class="fa fa-arrow-left"
                  onClick={() => navigator("/")}
                ></i>
              </div>
              <div className="page-ath-wrap profile-section">
                <div className="page-ath-content register-form-content coupon-page  coupon-page1 profile-section">
                  <div className="checkout-sign">
                    <div className="signin-form">
                      <div className="signin-page">
                        <div className="myaccount-information" id="myDIV">
                          {/* <h3>Profile</h3> */}
                          {/* <a
                        onClick={() => setUserEditProfile("profilesection")}
                        className={`account-box-1 ${userEditProfile === "profilesection" ? "Checked active-2" : ""}`}
                      >
                        <h6>Profile</h6>
                        <i className="fa-solid fa-chevron-right"></i>
                      </a> */}
                          {/* <a
                        onClick={() => setUserEditProfile("changepassword")}
                        className={`account-box-1 ${userEditProfile === "changepassword" ? "Checked active-2" : ""}`}
                      >
                        <h6>Change Password</h6>
                        <i className="fa-solid fa-chevron-right"></i>////
                      </a> */}
                          {/* <a
                        onClick={() => modelDisplay()}
                        className="account-box-1 logoutopen"
                      >
                        <h6>Logout</h6>
                        <i className="fa-solid fa-chevron-right"></i>
                      </a> */}
                        </div>
                      </div>
                      {userEditProfile === "profilesection" && (
                        <div className="signin-page-1">
                          {/* Profile Data Update Section  */}

                          <form
                            onSubmit={formik.handleSubmit}
                            className="signin-form-page profile-page"
                          >
                            <div className="signin-head">
                              <h2>Personal Information</h2>
                            </div>
                            <div className="detail-grid-1">
                              <div className="form-group">
                                <label>User Name</label>
                                <input
                                  type="text"
                                  placeholder="Enter your name"
                                  name="name"
                                  value={formik.values.name}
                                  onChange={formik.handleChange}
                                  readOnly
                                  className="detail-btn"
                                  style={{
                                    fontWeight: "500",
                                    color: "black",
                                  }}
                                />
                              </div>
                              <div className="form-group">
                                <label>Email Address</label>
                                <input
                                  type="text"
                                  placeholder="Enter your email"
                                  name="email"
                                  value={formik.values.email}
                                  onChange={formik.handleChange}
                                  readOnly
                                  className="detail-btn"
                                  style={{
                                    fontWeight: "500",
                                    color: "black",
                                  }}
                                />
                              </div>
                              {/* <div className="form-group">
                            <label>Phone No.</label>
                            <input
                              type="tel"
                              placeholder="Enter your phone no."
                              name='phone'
                              value={formik.values.phone}
                              onChange={formik.handleChange}
                              readOnly
                              className="detail-btn"
                              style={{fontWeight: '500', color: 'black'}}
                            />
                          </div> */}
                              {/* <div className="pro-button ">
                            <button type="submit">
                              <a >{loginButtonLoader ? "Submit" : "Plase wait"}</a>{" "}
                            </button>
                          </div> */}

                              {/* <!-- <div className="delet-account">
												<a href="#" className="PopupDelet">
													<i className="fa-solid fa-trash-can"></i>
													<span className="delet-account-u"><u>Delete account</u></span>
												</a> 
											</div> --> */}
                            </div>
                          </form>
                        </div>
                      )}
                      {userEditProfile === "changepassword" && (
                        <div className="signin-page-1">
                          <form
                            onSubmit={formikpass.handleSubmit}
                            className="signin-form-page profile-page"
                          >
                            <div className="signin-head">
                              <h2>Change Password</h2>
                            </div>

                            <div className="detail-grid-1">
                              <div className="form-group">
                                <label>Old Password</label>
                                <div style={{ position: "relative" }}>
                                  <input
                                    type={`${
                                      eyeIconManagersSinupConfirm
                                        ? "text"
                                        : "password"
                                    }`}
                                    placeholder="Enter your old password"
                                    name="oldPassword"
                                    value={formikpass.values.oldPassword}
                                    onChange={formikpass.handleChange}
                                    style={{
                                      fontWeight: "500",
                                      color: "black",
                                    }}
                                    className="detail-btn"
                                  />
                                  <i
                                    className={`${
                                      eyeIconManagersSinupConfirm
                                        ? "fa-regular fa-eye"
                                        : "fa-regular fa-eye-slash"
                                    }`}
                                    style={{
                                      position: "absolute",
                                      right: "20px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      fontSize: "large",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      setEyeIconManagersSinupConfirm(
                                        !eyeIconManagersSinupConfirm
                                      )
                                    }
                                  ></i>
                                </div>
                                {formikpass.touched.oldPassword &&
                                formikpass.errors.oldPassword ? (
                                  <div
                                    className="text-danger"
                                    style={{ float: "right" }}
                                  >
                                    {formikpass.errors.oldPassword}
                                  </div>
                                ) : null}
                              </div>
                              <div className="form-group">
                                <label>New Password</label>
                                <div style={{ position: "relative" }}>
                                  <input
                                    type={`${
                                      eyeIconManagersinup ? "text" : "password"
                                    }`}
                                    placeholder="Enter your new password"
                                    name="newPassword"
                                    value={formikpass.values.newPassword}
                                    onChange={formikpass.handleChange}
                                    style={{
                                      fontWeight: "500",
                                      color: "black",
                                    }}
                                    className="detail-btn"
                                  />
                                  <i
                                    className={`${
                                      eyeIconManagersinup
                                        ? "fa-regular fa-eye"
                                        : "fa-regular fa-eye-slash"
                                    }`}
                                    style={{
                                      position: "absolute",
                                      right: "20px",
                                      top: "39%",
                                      transform: "translateY(-50%)",
                                      fontSize: "large",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      setEyeIconManagersinup(
                                        !eyeIconManagersinup
                                      )
                                    }
                                  ></i>
                                </div>
                                {formikpass.touched.newPassword &&
                                formikpass.errors.newPassword ? (
                                  <div
                                    className="text-danger"
                                    style={{ float: "right" }}
                                  >
                                    {formikpass.errors.newPassword}
                                  </div>
                                ) : null}
                              </div>
                              <div className="form-group">
                                <label>Confirm Password</label>
                                <div style={{ position: "relative" }}>
                                  <input
                                    type={`${
                                      eyeIconManag ? "text" : "password"
                                    }`}
                                    placeholder="Enter your confirm password"
                                    name="confirmPassword"
                                    value={formikpass.values.confirmPassword}
                                    onChange={formikpass.handleChange}
                                    className="detail-btn"
                                    style={{
                                      fontWeight: "500",
                                      color: "black",
                                    }}
                                  />
                                  <i
                                    className={`${
                                      eyeIconManag
                                        ? "fa-regular fa-eye"
                                        : "fa-regular fa-eye-slash"
                                    }`}
                                    style={{
                                      position: "absolute",
                                      right: "20px",
                                      top: "39%",
                                      transform: "translateY(-50%)",
                                      fontSize: "large",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      setEyeIconManag(!eyeIconManag)
                                    }
                                  ></i>
                                </div>
                                {formikpass.touched.confirmPassword &&
                                formikpass.errors.confirmPassword ? (
                                  <div
                                    className="text-danger"
                                    style={{ float: "right" }}
                                  >
                                    {formikpass.errors.confirmPassword}
                                  </div>
                                ) : null}
                              </div>

                              <div className="pro-button ">
                                <button type="submit">
                                  <a>
                                    {loginButtonLoader
                                      ? "Submit"
                                      : "Plase wait"}
                                  </a>{" "}
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      )}

                      {/* {userEditProfile === 'logout' && (
                                    <> */}
                      {/* <div id="popuplogout" className="logout-page">
                    <div className="Coupon-details pd-0">
                      <div className="about-logout profile-logout">
                        <img
                          src="/assets/images/logout.png"
                          className="log-out"
                        />
                        <h4>
                          Are you sure, <span>you want to logout?</span>
                        </h4>
                        <div className="logout-btn">
                          <a href="#" className="Cancel">
                            Cancel
                          </a>
                          <a href="#" className="logout">
                            Logout
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="popupdelete" className="logout-page">
                    <div className="Coupon-details pd-0">
                      <div className="about-logout">
                        <h4>
                          Are you sure, <span>you want to Delete Account?</span>
                        </h4>
                        <div className="logout-btn">
                          <a href="#" className="Cancel-1">
                            Cancel
                          </a>
                          <a href="#" className="logout delete">
                            Delete
                          </a>
                        </div>
                      </div>
                    </div>
                  </div> */}
                      {/* </>
                                )} */}

                      <Modal
                        show={show}
                        onHide={handleClose}
                        centered
                        size="lg"
                        aria-labelledby="example-modal-sizes-title-lg"
                      >
                        {/* <Modal.Body></Modal.Body> */}
                        <div className="Coupon-details pd-0">
                          <div className="about-logout profile-logout">
                            <img
                              src="/assets/images/logout.png"
                              className="log-out"
                            />
                            <h4>
                              Are you sure, <span>you want to logout?</span>
                            </h4>
                            <div className="logout-btn">
                              <a onClick={() => setShow(false)}>Cancel</a>
                              <a onClick={() => logoutFun()} className="logout">
                                Logout
                              </a>
                            </div>
                          </div>
                        </div>
                      </Modal>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <FooterSection />
          </div>
        </>
      )}
      {/* </main>
        </div>
      </div> */}
    </>
  );
}

export default Profilesection